import { baseApi } from '../baseApi';
import { NewsItemTemplateModel } from '../../models/newsItemModel';
import { cleanObject } from 'utils/objectUtils';

export async function getNewsItems(topic?: string) {
  let url = '/officiating/newsItems?';
  let queryParamsObj = cleanObject({ topic });
  const queryParams = new URLSearchParams(queryParamsObj);
  return baseApi.get(url + queryParams);
}

export async function createNewsItem(data: NewsItemTemplateModel) {
  return baseApi.post('/officiating/newsItems/edit', { itemData: data });
}

export async function deleteNewsItem(newsItemId: string) {
  return baseApi.post(`/officiating/newsItems/edit/delete/${newsItemId}`);
}

export async function updateNewsItem(data: NewsItemTemplateModel) {
  const { newsItemId } = data;
  let url = `/officiating/newsItems/edit/update/${newsItemId}`;
  return baseApi.post(url, { itemData: data });
}
